import { type ICSVExport } from '@principle-theorem/ng-shared';
import { type IPractitionerGrouping } from '@principle-theorem/reporting';

export interface IInvoiceIssuedSelectorCSV {
  practitioner: string;
  treatmentsInvoicedAmount: string;
  labFeesAmount: string;
  depositsTakenAmount: string;
  discountsAppliedAmount: string;
  invoicedCommissionAmount: string;
}

export class InvoiceIssuedSelectorToCSV
  implements ICSVExport<IPractitionerGrouping, IInvoiceIssuedSelectorCSV>
{
  defaultFileName = 'practitioner-income-summary';
  headers = [
    'Practitioner',
    'Treatment Invoiced',
    'Lab Fees',
    'Deposits',
    'Discounts',
    'Recievable Amount',
  ];

  translate(records: IPractitionerGrouping[]): IInvoiceIssuedSelectorCSV[] {
    return records.map((record) => ({
      practitioner: record.practitioner.name,
      treatmentsInvoicedAmount:
        record.total.treatmentsInvoicedAmount.toString(),
      labFeesAmount: record.total.labFeesAmount.toString(),
      depositsTakenAmount: record.total.depositsTakenAmount.toString(),
      discountsAppliedAmount: record.total.discountsAppliedAmount.toString(),
      invoicedCommissionAmount:
        record.total.invoicedCommissionAmount.toString(),
    }));
  }
}
